import i18next from "i18next";
import { reactI18nextModule } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/en.json";
import translationME from "./locales/me/me.json";

const resources = {
  en: { translation: translationEN },
  me: { translation: translationME },
  sr: { translation: translationME }, // use same translation as Montenegrian
};

i18next
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    resources,
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage"],
    },
    supportedLngs: ["en", "me", "sr"],
    load: "languageOnly", // if `sr-ME`, use just `sr`
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
